import React from 'react';

import { Button, Input, Select } from '@chakra-ui/react';

import AddIcon from '@/assets/AddIcon';
import { COLORS } from '@/common/constants';

import '../styles/ListPage.css';

interface SearchAndFilterProps {
    searchValue: string;
    setSearchValue: (value: string) => void;
    statusValue: string;
    setStatusValue: (value: string) => void;
    typeValue: string;
    setTypeValue: (value: string) => void;
    onSearch: () => void;
    onAdd: () => void;
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
    searchValue,
    setSearchValue,
    statusValue,
    setStatusValue,
    typeValue,
    setTypeValue,
    onSearch,
    onAdd,
}) => (
    <div className="table-filter-action-container">
        <div className="table-filter-container">
            <div className='table-filter-input filter-input-width-5'>
                <Input
                    placeholder='Search'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
            <div className='table-filter-input filter-input-width-3'>
                <Select
                    placeholder='All Status'
                    value={statusValue}
                    onChange={(e) => setStatusValue(e.target.value)}
                >
                    <option value="1">New</option>
                    <option value="2">In Review</option>
                    <option value="3">Active</option>
                    <option value="4">Rejected</option>
                    <option value="5">Inactive</option>
                </Select>
            </div>
            <div className='table-filter-input filter-input-width-3'>
                <Select
                    placeholder='All Type'
                    value={typeValue}
                    onChange={(e) => setTypeValue(e.target.value)}
                >
                    <option value="sirebire">SIRE</option>
                    <option value="vetting">Vetting</option>
                </Select>
            </div>
            <div>
                <Button
                    className='table-search-button'
                    bgColor={COLORS.BUTTON.BACKGROUND}
                    color={COLORS.BUTTON.FOREGROUND}
                    variant='solid'
                    borderRadius={10}
                    onClick={onSearch}
                >
                    Search
                </Button>
            </div>
            <div className="table-filter-separator"/>
            <Button
                leftIcon={<AddIcon />}
                bgColor={COLORS.BUTTON.BACKGROUND}
                color={COLORS.BUTTON.FOREGROUND}
                className='table-add-button'
                variant='solid'
                borderRadius={10}
                onClick={onAdd}
            >
                Add Inspecting Company
            </Button>
        </div>
    </div>
);

export default SearchAndFilter;
